import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Box, CircularProgress, Container, Stack } from '@mui/material';
import ShadowBlock from '../../../atoms/ShadowBlock';
import ChangeLog from '../../../molecules/ChangeLog';
import AddCommentNew from '../../../molecules/AddComment/AddCommentNew';
import { dataAddComment } from '../../../molecules/AddComment/constant';
import NotesNew from '../../../organisms/Notes/NotesNew';
import { addNoteToCase, getCaseNotes } from '../../../../store/slices/cases/casesGeneralSlice';
import { getCaseLogs } from '../../../../store/slices/logsSlice';
import { MAX_AMOUNT_OF_ITEMS_ON_CASE_PAGE } from '../../../molecules/ChangeLog/ChangeLog.constants';
import notificationUtils from '../../../../utils/notificationUtils';

const CaseNotes = () => {
  const dispatch = useDispatch();
  const {
    state: { id },
  } = useLocation();
  const [isLoader, setIsLoader] = useState(true);
  const { notes } = useSelector((state) => state.casesGeneral);

  const [isLogLoader, setIsLogLoader] = useState(true);
  const data = useSelector((state) => state.logs.caseLogs);

  const onFetchPage = useCallback(
    (params = { pageSize: MAX_AMOUNT_OF_ITEMS_ON_CASE_PAGE, currentPage: 1 }) => {
      setIsLogLoader(true);

      return dispatch(
        getCaseLogs({
          ...params,
          id,
        }),
      ).then(() => {
        setIsLogLoader(false);
      });
    },
    [id],
  );

  useEffect(() => {
    dispatch(getCaseNotes(id)).then(() => setIsLoader(false));
    onFetchPage();
  }, [id]);

  const handleAddComment = useCallback((comment) => {
    setIsLoader(true);

    dispatch(addNoteToCase({ id, caseId: id, comment }))
      .unwrap()
      .then(() => dispatch(getCaseNotes(id)).then(() => setIsLoader(false)))
      .catch((e) => {
        notificationUtils.error(e);
        setIsLoader(false);
      });
  }, []);

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        mx: 'auto',
        mt: 4,
        px: 4,
        maxWidth: 1542,
        width: 1,
      }}
      data-testid="case_notes_wrapper"
    >
      <Stack spacing={4} pb={4}>
        <ShadowBlock>
          <>
            {!!notes?.length && !isLoader && <NotesNew title="Case Notes" list={notes} />}
            {isLoader && (
              <Box
                position="absolute"
                top="50%"
                left="50%"
                zIndex={10}
                transform="translate(-50%, -50%)"
              >
                <CircularProgress data-testid="circular_progress" />
              </Box>
            )}
            <AddCommentNew
              title={dataAddComment.title}
              inputPlaceholder={dataAddComment.inputPlaceholder}
              buttonText={dataAddComment.buttonText}
              onAddComment={handleAddComment}
              tooltip="Notes are for internal use only."
            />
          </>
        </ShadowBlock>

        <ChangeLog
          rows={data?.items ?? []}
          total={data?.totalRowsCount}
          isPagination={data?.totalPages > 1}
          onFetchPage={onFetchPage}
          loading={isLogLoader}
          pageSize={MAX_AMOUNT_OF_ITEMS_ON_CASE_PAGE}
        />
      </Stack>
    </Container>
  );
};

export default CaseNotes;
